import { render, staticRenderFns } from "./IconUpgrade.vue?vue&type=template&id=4adb091e&scoped=true"
import script from "./IconUpgrade.vue?vue&type=script&lang=js"
export * from "./IconUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb091e",
  null
  
)

export default component.exports